function makeImgCompCacheKey(productImg, optionValues) {
  return `${productImg.id}_${optionValues.join("_")}`;
}

function getImgElements(img){
  const srcQ = img.src.split("_1000x1000")[0];
  const imgName = srcQ?.split("/").pop();
  return document.querySelectorAll(`img[data-media-id='${img.id}'], [data-media-id='${img.id}'] img, img[src*='${srcQ}'], img[data-srcq='${srcQ}'], img[src*='${imgName}']`);
}
function updateImagesWithLayers(img, url){
  const srcQ = img.src.split("_1000x1000")[0];
  const images = getImgElements(img);
//   console.log(`Updating ${images.length} image(s) for media ID ${img.id}`, images);
  images.forEach(el => {
    el.src = url;
    el.srcset = url;
    el.setAttribute("data-srcq", srcQ);
    /* zoom-fix: store composite on the .product__media-item so PhotoSwipe uses it */
    const mediaItem = el.closest(".product__media-item");
    if(mediaItem){
      mediaItem.dataset.compositedSrc = url;
    }
  });
}

function showImageLoader(img){
  const images = getImgElements(img);
  const turtleLoader = document.getElementById("turtle-loader")?.content?.firstElementChild;
  images.forEach(el => {
    if(!el.parentElement?.querySelector(".dk-spinner-container")){
      el.insertAdjacentHTML("afterend", `<div class="dk-spinner-container">${turtleLoader?.outerHTML || '<span class="dk-spinner"></span>'}</div>`);
    }
  });
}

function hideImageLoader(img){
  const images = getImgElements(img);
  images.forEach(el => {
    el.parentElement?.querySelectorAll(".dk-spinner-container")?.forEach(container => container.remove());
  });
}

async function compositeImages(imageUrls, width, height, format = 'image/png', quality = 1) {
  return new Promise((resolve, reject) => {
      try {
          // Create canvas with specified dimensions
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          
          // Set composite operation for stacking
          ctx.globalCompositeOperation = 'source-over';
          
          // Counter to track loaded images
          let loadedImages = 0;
          const totalImages = imageUrls.length;
          
          if (totalImages === 0) {
              reject(new Error('No images provided'));
              return;
          }
          const loadedImageObjects = [];
          // Load and draw each image
          imageUrls.forEach((url, index) => {
              const img = new Image();
              
              img.onload = function() {
                  loadedImageObjects[index] = img;                  
                  loadedImages++;
                  
                  // If all images are loaded, return the composite
                  if (loadedImages === totalImages) {
                    // draw all images in sequesnce
                      loadedImageObjects.forEach(image => ctx.drawImage(image, 0, 0, width, height));
                      try {
                          const dataUrl = canvas.toDataURL(format, quality);
                          resolve(dataUrl);
                      } catch (error) {
                          reject(new Error(`Failed to generate data URL: ${error.message}`));
                      }
                  }
              };
              
              img.onerror = function() {
                  reject(new Error(`Failed to load image: ${url}`));
              };
              
              // Handle CORS if needed
              img.crossOrigin = 'anonymous';
              img.src = url;
          });
          
      } catch (error) {
          reject(new Error(`Canvas setup failed: ${error.message}`));
      }
  });
}

function observeNewImages(targets, onImg, options = { childList: true, subtree: true }) {
  // Normalize input into an array of Elements
  const elements = (() => {
    if (!targets) return [];
    return [...document.querySelectorAll(targets)];
  })();
  const observers = elements.map((container) => {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type !== "childList") continue;
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== Node.ELEMENT_NODE) continue;
          // 1) node itself is an IMG
          if (node.matches?.("img")) {
            onImg(node, { container, mutation });
          }
          // 2) node contains IMG(s)
          node.querySelectorAll?.("img").forEach((img) => {
            onImg(img, { container, mutation });
          });
        }
      }
    });
    observer.observe(container, options);
    container.setAttribute("data-observe-new-images", "true");
    return observer;
  });
  return {
    observers,
    disconnect: () => observers.forEach((o) => o.disconnect()),
  };
}

function handleToggleColorOptions(ev){
  const parent = ev.closest("#color-preview-container");
  parent.classList.toggle("dk-color-option-active");
}

function handleColorOptionClick(el, color){
  el.closest("#color-preview-container").classList.remove("dk-color-option-active");
  const event = new CustomEvent("dk_color:change", { detail: { color: color, element: el } });
  document.dispatchEvent(event);
}

/* 24.10.2026: Der Gerätefarbe-Button gehört nur zu Bildern, die wirklich
   umgefärbt werden (Ebenen in window.dk.imageLayers). Auf Fotos ohne Ebenen
   wird er ausgeblendet. Index von imageLayers entspricht productImages. */
function colorableMediaIds(){
  const ids = new Set();
  (window.dk?.productImages || []).forEach((img, i) => {
    const layers = window.dk?.imageLayers?.[i];
    if (layers && Object.values(layers).some(v => !!v)) ids.add(String(img.id));
  });
  return ids;
}
function updateColorBadgeVisibility(){
  const container = document.getElementById("color-preview-container");
  if (!container) return;
  const ids = colorableMediaIds();
  const selected = document.querySelector(".product__media-item.is-selected:not(.is-filtered)")
    || document.querySelector(".product__media-item.is-initial-selected");
  const mediaId = selected ? String(selected.getAttribute("data-media-id")) : null;
  const show = !!mediaId && ids.has(mediaId);
  container.style.display = show ? "" : "none";
  if (!show) container.classList.remove("dk-color-option-active");
}
document.addEventListener("flickity:slide-changed", updateColorBadgeVisibility);
document.addEventListener("flickity:slide-settled", updateColorBadgeVisibility);
document.addEventListener("variant:changed", () => setTimeout(updateColorBadgeVisibility, 50));

function generateColorPreviewUI(selectedColor){
  if(!selectedColor || !window.dk.colorPreviews || window.dk.colorPreviews.length === 0) return;
  document.querySelectorAll("#color-preview-container").forEach(el => el.remove());
  const container = document.createElement("div");
  container.id = "color-preview-container";
  container.innerHTML = `
    <div class="dk-selected-color" onclick="handleToggleColorOptions(this)"><span class="dk-selected" style="--bg-color: ${selectedColor.color};"></span><span class="dk-label">Gerätefarbe</span></div>
    <div class="dk-color-options">
      <div class="dk-color-options-outer">
        <span class="dk-bar"></span>
        <div class="dk-color-options-header">
          <h1>Wähle dein Gerätefarbe</h1>
          <span onclick="handleToggleColorOptions(this)">Schließen</span>
        </div>
        <span class="dk-color-option-name">${selectedColor.label}</span>
        <div class="dk-color-options-inner">
        ${window.dk.colorPreviews.map(c => `
          <div class="dk-color-option ${c.color === selectedColor.color ? "active" : ""}" data-color="${c.color}" onclick="handleColorOptionClick(this, '${c.color}')">
            <span class="dk-color" style="background-color: ${c.color};"></span>
            <span style="font-size: 14px;">${c.label}</span>
          </div>
        `).join("")}
        </div>
      </div>
    </div>
  `;
    document.querySelectorAll(".tap-area.product__zoom-button").forEach(el => el.insertAdjacentElement("afterend", container));
    updateColorBadgeVisibility();
    document.querySelectorAll(".dk-color-options").forEach(el => {
      el.style.display = "flex";
      el.style.position = "relative";
      el.style.setProperty("--dk-color-options-width", `${el.offsetWidth}px`);
      el.style.display = "";
      el.style.position = "";
    });
}

document.addEventListener("DOMContentLoaded", function () {
  /* Safe defaults — window.dk is only injected on layer-v2 view; default template would otherwise throw and kill all toggle bindings below. */
  window.dk = window.dk || {};
  window.dk.colorPreviews    = window.dk.colorPreviews    || [];
  window.dk.imageLayers      = window.dk.imageLayers      || [];
  window.dk.productImages    = window.dk.productImages    || [];
  window.dk.variantPhonetypes= window.dk.variantPhonetypes|| {};
  if (!("selectedPhoneModel" in window.dk)) window.dk.selectedPhoneModel = null;

  const IMG_COMPOSITION_CACHE = {};
  let IMG_OBSERVER = null;
  let SELECTED_COLOR = window.dk.colorPreviews[0] || null;
  
  /* Checkboxes */
  const cbSchutzglas = document.getElementById("checkbox-schutzglas");
  const cbMagsafe   = document.getElementById("checkbox-magsafe");
  const cbKamera    = document.getElementById("checkbox-kamera");
  const cbCable     = document.getElementById("checkbox-cable");
  const cbLanyard   = document.getElementById("checkbox-lanyard");

  /* Selects */
  const varSchutzglas = document.getElementById("variant-schutzglas");
  const varMagsafe    = document.getElementById("variant-magsafe");
  const varKamera     = document.getElementById("variant-kamera");
  const varCable      = document.getElementById("variant-cable");
  const varLanyard    = document.getElementById("variant-lanyard");

  /* Toggle-Buttons */
  document.getElementById("btn-schutzglas-on").onclick = () => { cbSchutzglas.checked = true;  updateUI("schutzglas"); };
  document.getElementById("btn-schutzglas-off").onclick= () => { cbSchutzglas.checked = false; updateUI("schutzglas"); };
  document.getElementById("btn-magsafe-on").onclick    = () => { cbMagsafe.checked   = true;  updateUI("magsafe");   };
  document.getElementById("btn-magsafe-off").onclick   = () => { cbMagsafe.checked   = false; updateUI("magsafe");   };
  document.getElementById("btn-kamera-on").onclick     = () => { cbKamera.checked    = true;  updateUI("kamera");    };
  document.getElementById("btn-kamera-off").onclick    = () => { cbKamera.checked    = false; updateUI("kamera");    };
  document.getElementById("btn-cable-on").onclick      = () => { cbCable.checked     = true;  updateUI("cable");     };
  document.getElementById("btn-cable-off").onclick     = () => { cbCable.checked     = false; updateUI("cable");     };
  if (cbLanyard) {
    document.getElementById("btn-lanyard-on").onclick   = () => { cbLanyard.checked  = true;  updateUI("lanyard");   };
    document.getElementById("btn-lanyard-off").onclick  = () => { cbLanyard.checked  = false; updateUI("lanyard");   };
  }

  /* --- Robustheit: beim Start ALLES auf ON setzen, sofern verfügbar --- */
  cbSchutzglas.checked = true;
  cbMagsafe.checked    = true;
  cbKamera.checked     = (varKamera && varKamera.options[0] && !varKamera.options[0].disabled);
  cbCable.checked      = (varCable  && varCable.options[0]  && !varCable.options[0].disabled);
  if (cbLanyard) { cbLanyard.checked = false; }

  /* Image Layer Update closure function */
  async function updateImageLayers(SELECTED_COLOR){
    const isGlasEnabled = cbSchutzglas.checked;
    const isMagsafeEnabled = cbMagsafe.checked;
    const isKameraEnabled = cbKamera.checked;
    const isCableEnabled = cbCable.checked;
    const isLanyardEnabled = cbLanyard ? cbLanyard.checked : false;
    
    window.dk.productImages.forEach((img, index) => {
      const layers = window.dk.imageLayers[index];
      if(layers && Object.values(layers).some(val => !!val)) {        
        const cacheKey = makeImgCompCacheKey(img, [isGlasEnabled, isMagsafeEnabled, isKameraEnabled, isCableEnabled, isLanyardEnabled, SELECTED_COLOR?.color || "none"]);
        showImageLoader(img);
        const chached = IMG_COMPOSITION_CACHE[cacheKey];
        if(chached){
          updateImagesWithLayers(img, chached.compositeUrl)
        //   console.log("Layers updating from cache", chached.overlayUrls, cacheKey)
          hideImageLoader(img);
        }else{
          const overlayUrls = [
            "https://" + img.src.split("//").pop(),
            ...(SELECTED_COLOR?.imgURL ? ["https://" + SELECTED_COLOR.imgURL.split("//").pop()] : []),
            ...(isMagsafeEnabled && layers.magsafe ? ["https://" + layers.magsafe.split("//").pop()] : []),
            /* Lanyard UNTER Case/Design: Band darf das Motiv nie überdecken —
               sichtbar bleiben nur Kordeln außerhalb der Hülle (Spec 16.07.) */
            ...(isLanyardEnabled && layers.lanyard ? ["https://" + layers.lanyard.split("//").pop()] : []),
            ...(layers.case ? ["https://" + layers.case.split("//").pop()] : []),
            ...(layers.caseextralayer ? ["https://" + layers.caseextralayer.split("//").pop()] : []),
            ...(isGlasEnabled && layers.schutzglas ? ["https://" + layers.schutzglas.split("//").pop()] : []),
            ...(isKameraEnabled && layers.kamera ? ["https://" + layers.kamera.split("//").pop()] : []),
            ...(isCableEnabled && layers.cable ? ["https://" + layers.cable.split("//").pop()] : [])
          ];
          compositeImages(
            overlayUrls,
            1000,
            1000
          ).then(url => {
            updateImagesWithLayers(img, url);
            IMG_COMPOSITION_CACHE[cacheKey] = { compositeUrl: url, overlayUrls: overlayUrls };
            // console.log("Layers regenerated", overlayUrls);
          }).finally(() => {
            hideImageLoader(img);
          }).catch(err => console.error("Image composition failed for image index " + index, err));
        }
      }
    });
  }

  /* Initial image layer update and new image observation setup */
  document.addEventListener("flickity:ready", function(el) {
    updateImageLayers(SELECTED_COLOR);
    generateColorPreviewUI(SELECTED_COLOR);
    IMG_OBSERVER?.disconnect();
    IMG_OBSERVER = observeNewImages(`product-image-zoom[product-handle="{{ product.handle }}"]`, (img, { container }) => {
        updateImageLayers(SELECTED_COLOR);
    });
  });
  document.addEventListener("dk_color:change", function(ev) {
    SELECTED_COLOR = window.dk.colorPreviews.find(c => c.color === ev.detail.color) || SELECTED_COLOR;
    const parent = ev.detail.element.closest("#color-preview-container");
    parent.querySelector(".dk-selected").style.setProperty("--bg-color", ev.detail.color);
    parent.querySelector(".dk-color-option-name").textContent = SELECTED_COLOR.label;
    parent.querySelectorAll(".dk-color-option").forEach(el => el.classList.toggle("active", el.getAttribute("data-color") === ev.detail.color));
    updateImageLayers(SELECTED_COLOR);
  });
  document.addEventListener("click", function(ev){
    const activePreview = document.querySelectorAll(".dk-color-option-active");
    if(activePreview.length > 0 && (!ev.target.closest("#color-preview-container") || (window.innerWidth <= 999 && ev.target.closest(".dk-color-options") && !ev.target.closest(".dk-color-options-outer")))){
      ev.preventDefault();
      ev.stopImmediatePropagation();
      activePreview.forEach(el => el.classList.remove("dk-color-option-active"));
    }
  }, true)

  function updateUI(type, initial = false) {
    switch (type) {
      case "schutzglas":
        toggleState(cbSchutzglas.checked, "btn-schutzglas-on", "btn-schutzglas-off", "soldout-schutzglas", varSchutzglas);
        break;
      case "magsafe":
        toggleState(cbMagsafe.checked, "btn-magsafe-on", "btn-magsafe-off", "soldout-magsafe", varMagsafe);
        break;
      case "lanyard":
        if (cbLanyard) toggleState(cbLanyard.checked, "btn-lanyard-on", "btn-lanyard-off", "soldout-lanyard", varLanyard);
        updateImageLayers(SELECTED_COLOR);
        break;
      case "kamera":
        toggleState(cbKamera.checked, "btn-kamera-on", "btn-kamera-off", "soldout-kamera", varKamera);
        break;
      case "cable":
        toggleState(cbCable.checked, "btn-cable-on", "btn-cable-off", "soldout-cable", varCable);
        break;
    }
    /* update Image layers on every change, but skip on initial load to avoid unnecessary processing before Flickity is ready */
    if(!initial) {
      updateImageLayers(SELECTED_COLOR);
    }
  }

  function toggleState(checked, btnOnId, btnOffId, soldOutId, selectEl) {
    document.getElementById(btnOnId).classList.toggle("active", checked);
    document.getElementById(btnOffId).classList.toggle("active", !checked);
    const selectedOpt = selectEl && selectEl.options ? selectEl.options[selectEl.selectedIndex] : null;
    document.getElementById(soldOutId).classList.toggle("active", selectedOpt ? selectedOpt.disabled : false);
  }

  /* Beim Add-to-Cart Upsells hinzufügen */
  window.updateAllUpsells = function (parentKey) {
    const upsells = [];

    if (cbSchutzglas.checked && varSchutzglas.options[varSchutzglas.selectedIndex] && !varSchutzglas.options[varSchutzglas.selectedIndex].disabled) {
      upsells.push({ id: varSchutzglas.value, quantity: 1 });
    }
    if (cbMagsafe.checked && varMagsafe.options[varMagsafe.selectedIndex] && !varMagsafe.options[varMagsafe.selectedIndex].disabled) {
      upsells.push({ id: varMagsafe.value, quantity: 1 });
    }
    if (cbKamera.checked && varKamera.options[varKamera.selectedIndex] && !varKamera.options[varKamera.selectedIndex].disabled) {
      upsells.push({ id: varKamera.value, quantity: 1 });
    }
    if (cbCable.checked && varCable.options[varCable.selectedIndex] && !varCable.options[varCable.selectedIndex].disabled) {
      upsells.push({ id: varCable.value, quantity: 1 });
    }
    if (cbLanyard && cbLanyard.checked && varLanyard && varLanyard.options[varLanyard.selectedIndex] && !varLanyard.options[varLanyard.selectedIndex].disabled) {
      upsells.push({ id: varLanyard.value, quantity: 1 });
    }

    /* Nested Cart Lines (17.10.2026): Zusatzartikel haengen an der Huellen-Zeile.
       Shopify zeigt sie im Checkout eingerueckt und entfernt sie mit der Huelle. */
    if (parentKey) upsells.forEach(function (u) { u.parent_line_key = parentKey; });
    if (upsells.length > 0) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: upsells })
      })
      .then(res => res.json())
      .then(() => {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(err => console.error("Upsell hinzufügen fehlgeschlagen:", err));
    }
  };

  /* Matching-Funktion (nur SCHUTZGLAS) */
  /* Titel "iPhone 15 pro / iPhone 15 pro max" -> ["iphone 15 pro", "iphone 15 pro max"].
     "– Ausverkauft"-Suffix (disabled Options) wird vor dem Split entfernt. */
  function phonetypeSegments(text) {
    return String(text || "")
      .toLowerCase()
      .replace(/\s*–\s*ausverkauft\s*$/i, "")
      .split("/")
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
  }

  /* Wählt die Variante, deren Titel-Segment exakt einem phonetype-Segment entspricht.
     Exakt statt Substring: "iPhone 16" darf NICHT "iPhone 16 pro / ..." treffen.
     Auch ausverkaufte (disabled) Treffer werden selektiert, damit die Soldout-Anzeige
     greift und updateAllUpsells sie NICHT in den Warenkorb legt.
     Return: true = verfügbarer Treffer, "soldout" = Treffer ausverkauft, false = kein Treffer. */
  function matchVariantByPhonetype(selectEl, phonetype) {
    if (!phonetype || !selectEl) return false;
    const want = phonetypeSegments(phonetype);
    const opts = selectEl.options;
    /* Alle Segment-Treffer sammeln: Kombi-Hüllen wie "iPhone 12 pro / iPhone 12"
       können auf ZWEI verschiedene Gläser zeigen (12 pro eigenes Kamera-Glas!) —
       dann ist das richtige Glas nicht bestimmbar -> kein Match (Block wird versteckt). */
    const hits = [];
    for (let i = 0; i < opts.length; i++) {
      const have = phonetypeSegments(opts[i].textContent);
      if (want.some(function (w) { return have.indexOf(w) > -1; })) hits.push(i);
    }
    if (hits.length > 1) return false;
    let hit = hits.length === 1 ? hits[0] : -1;
    if (hit < 0) {
      /* Fallback: altes Substring-Verhalten für Legacy-Titel */
      for (let i = 0; i < opts.length && hit < 0; i++) {
        if (opts[i].textContent && opts[i].textContent.indexOf(phonetype) > -1) hit = i;
      }
    }
    if (hit < 0) return false;
    opts[hit].selected = true;
    return opts[hit].disabled ? "soldout" : true;
  }

  /* Ladekabel: 2 Varianten „USB-C auf Lightning" (iPhone ≤ 14) + „USB-C auf USB-C"
     (iPhone 15+ & alle Samsung). Regelbasiert (nicht per Titel-Segment wie Glas):
     iPhones mit Lightning-Port = alle bis inkl. 14 sowie X/Xr/Xs/SE/7/8/11/12/13;
     ab iPhone 15, 16e/17e und alle Samsung/Sonstige = USB-C. */
  function cableTypeForPhone(phonetype) {
    const p = String(phonetype || "").toLowerCase();
    if (!p) return "usbc";                 // unbekannt -> USB-C (heutiger Standard)
    if (p.indexOf("samsung") > -1) return "usbc";
    if (/1[6-9]e/.test(p)) return "usbc";  // 16e / 17e -> USB-C
    var nums = (p.match(/\d+/g) || []).map(Number);
    var maxN = nums.length ? Math.max.apply(null, nums) : 0;
    return maxN >= 15 ? "usbc" : "lightning";  // 0 (X/Xr/Xs) & ≤14 -> Lightning
  }

  /* Waehlt im Kabel-Select die passende Variante. Lightning-Variante = Titel enthaelt
     „lightning"; USB-C-Variante = enthaelt „usb-c" ohne „lightning". */
  function matchCableByPhonetype(selectEl, phonetype) {
    if (!selectEl) return false;
    var want = cableTypeForPhone(phonetype);
    var opts = selectEl.options, hit = -1;
    for (var i = 0; i < opts.length; i++) {
      var t = (opts[i].textContent || "").toLowerCase();
      var isLightning = t.indexOf("lightning") > -1;
      if (want === "lightning" ? isLightning : !isLightning) { hit = i; break; }
    }
    if (hit < 0) return false;
    opts[hit].selected = true;
    return opts[hit].disabled ? "soldout" : true;
  }

  /* Upsell-Block ein-/ausblenden je nach Match-Ergebnis: Ohne passende Variante
     (z.B. Samsung ohne Glas im Sortiment) wird der Block versteckt und abgewählt —
     vorher wurde stillschweigend die Default-Variante (falsches Glas!) verkauft. */
  function applyMatchResult(result, checkboxEl, selectEl) {
    const block = selectEl ? selectEl.closest(".upsell-block") : null;
    if (result === false) {
      if (block) block.style.display = "none";
      if (checkboxEl) checkboxEl.checked = false;
    } else if (block) {
      block.style.display = "";
    }
  }

  /* Initiales Mapping – NUR Schutzglas.
     window.dk.selectedPhoneModel kann null sein wenn das Snippet via innerHTML injiziert wird
     (Script-Tags in innerHTML werden nicht ausgeführt). Fallback: #variant-phonetype DOM-Attribut. */
  function getPhonetype() {
    const fromDk = window.dk.selectedPhoneModel;
    if (fromDk) return fromDk;
    return document.getElementById("variant-phonetype")?.dataset?.initialPhonetype || null;
  }
  applyMatchResult(matchVariantByPhonetype(varSchutzglas, getPhonetype()), cbSchutzglas, varSchutzglas);
  applyMatchResult(matchVariantByPhonetype(varKamera, getPhonetype()), cbKamera, varKamera);
  applyMatchResult(matchCableByPhonetype(varCable, getPhonetype()), cbCable, varCable);

  /* Bei Variantenwechsel phonetype neu mappen – Schutzglas + Kamera + Kabel */
  document.addEventListener('change', function (event) {
    if (event.target.name === "id") {
      const selectedVariantId = event.target.value;
      const phonetype = window.dk.variantPhonetypes[selectedVariantId] || getPhonetype();
      if (phonetype) {
        applyMatchResult(matchVariantByPhonetype(varSchutzglas, phonetype), cbSchutzglas, varSchutzglas);
        updateUI("schutzglas");
        applyMatchResult(matchVariantByPhonetype(varKamera, phonetype), cbKamera, varKamera);
        updateUI("kamera");
        applyMatchResult(matchCableByPhonetype(varCable, phonetype), cbCable, varCable);
        updateUI("cable");
      }
    }
  });

  /* Line-Item-Property "MagSafe: ja" (03.08.–22.09.2026) wieder entfernt: Owner 22.09.,
     "verwirrt mehr als es hilft". Die Zuordnung laeuft wieder ueber den 5-€-MagSafe-Artikel. */
  /* UI-Status initial setzen */
  updateUI("schutzglas", true);
  updateUI("magsafe", true);
  if (cbLanyard) updateUI("lanyard", true);
  updateUI("kamera", true);
  updateUI("cable", true);

  generateColorPreviewUI(SELECTED_COLOR);
  updateImageLayers(SELECTED_COLOR);

  /* Add-to-Cart Button hooken.
     16.10.2026: Vorher fester Timer (800 ms nach Klick). Ohne Cart-Cookie (erster Kauf) kam der
     Upsell-Request vor der Antwort auf den Huellen-Request an, Shopify legte zwei Warenkoerbe an
     und die Huelle ging verloren. Jetzt: Klick merkt sich nur die Absicht, gesendet wird erst beim
     Theme-Ereignis variant:added (feuert nach erfolgreicher Antwort, Cookie ist dann gesetzt).
     Kein Timer-Fallback, sonst kommt der Race zurueck. */
  const atcBtn = document.getElementById('AddToCart');
  if (atcBtn) {
    let upsellsAusstehend = false, upsellsReset = null;
    atcBtn.addEventListener('click', function () {
      upsellsAusstehend = true;
      clearTimeout(upsellsReset);
      upsellsReset = setTimeout(function () { upsellsAusstehend = false; }, 15000); /* Absicht verfaellt, falls das Hinzufuegen scheitert */
    });
    document.addEventListener('variant:added', function (ev) {
      if (!upsellsAusstehend) return;
      if (ev.target && ev.target.contains && !ev.target.contains(atcBtn)) return; /* nur das Formular der Huelle, nicht andere Add-Quellen */
      upsellsAusstehend = false;
      clearTimeout(upsellsReset);
      var v = ev.detail && ev.detail.variant;
      updateAllUpsells(v && v.key ? v.key : null);
    });
  }
});